import { request } from './Request';
import { routes } from '../constants/constant.route';

const {
  GET_USER_INFO,
  UPDATE_USER_INFO,
  UPLOAD_PROFILE_IMAGE,
  UPDATE_DETAIL_REQUEST,
  CHANGE_PASSWORD,
  SEARCH_FLEET,
  SEARCH_DEALER
} = routes.USER;

const {
  SAVE_TOKEN,
  GET_NOTIFICATION,
  GET_UNREAD_NOTIFICATION_COUNT
} = routes.OTHER;


const API_URL = process.env.REACT_APP_API_URL;

export default class UserService {

  static getUserInfo(fleet_id) {
    let qp = '';
    if (fleet_id) {
      qp = `?id=${fleet_id}`;
    }
    return request('GET', `${API_URL}${GET_USER_INFO}${qp}`, null, null, null);
  }

  static searchFleet(query) {
    let qp = '';
    if (query) {
      qp = `?q=${query}`;
    }
    return request('GET', `${API_URL}${SEARCH_FLEET}${qp}`, null, null, null);
  }

  static updateUserInfo(obj) {
    let qp = '';
    if (obj.fleet_id) {
      qp = `?id=${obj.fleet_id}`;
    }
    return request('POST', `${API_URL}${UPDATE_USER_INFO}${qp}`, null, obj, null);
  }

  static sendUpdateDetailRequest(obj) {
    return request('POST', `${API_URL}${UPDATE_DETAIL_REQUEST}`, null, obj, null);
  }

  static uploadImage(image) {
    const headers = {
      'content-type': 'multipart/form-data'
    };
    return request('POST', `${API_URL}${UPLOAD_PROFILE_IMAGE}`, null, image, headers);
  }

  static uploadImageProfile(id, image) {
    const headers = {
      'content-type': 'multipart/form-data'
    };
    let qp = '';
    if (id) {
      qp = `?id=${id}`;
    }
    return request('POST', `${API_URL}${UPLOAD_PROFILE_IMAGE}${qp}`, null, image, headers);
  }

  static updatePassword(body) {
    return request('POST', `${API_URL}${CHANGE_PASSWORD}`, null, body, null);
  }

  static saveToken(obj) {
    return request('POST', `${API_URL}${SAVE_TOKEN}`, null, obj, null);
  }

  static getNotification(q) {
    return request('GET', `${API_URL}${GET_NOTIFICATION}?page=${q.page}&pagesize=${q.pagesize}`, null, null, null);
  }

  static getUnreadNotificationCount() {
    return request('GET', `${API_URL}${GET_UNREAD_NOTIFICATION_COUNT}`, null, null, null);
  }

  static searchDealer(query, uuid) {
    let qp = "?";
    if (query) {
      qp += `q=${query}&`;
    }
    if (uuid) {
      qp += `u=${uuid}`;
    }
    return request("GET", `${API_URL}${SEARCH_DEALER}${qp}`, null, null, null);
  }

}